import { Button, Row } from 'react-bootstrap';
import TextField from '../../../../../../../../../../component/TextField';
import ProvisonalDiagnosis from '../../../../../../../../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import ICD10 from '../../../../../../../../../../phan-he-kham-benh/components/ICD10';
import { getIndexedDBItem } from '../../../../../../../../../../utils/IndexedDB';
import { KEY_DS_DANH_MUC_TIEP_DON } from '../../../../../../../../../../utils/Constant';
import { IDanhSachDanhMuc } from '../../../../../../../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';

type Props = {
	showPhanBiet?: boolean
}

const ThongTinBenh = ({
	showPhanBiet = true
}: Props) => {
	const { values, errors, touched, setValues, setFieldValue } = useFormikContext<any>();

	const [listComorbidity, setListComorbidity] = useState<any[]>([]);
	const [openICD10Dialog, setOpenICD10Dialog] = useState(false);
	const [openSelectICD10Dialog, setOpenSelectICD10Dialog] = useState(false);
	const [listICD10, setListICD10] = useState<any[]>([]);

	useEffect(() => {
		getDanhMuc();
	}, []);

	const getDanhMuc = async () => {
		const danhMuc: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
		setListICD10(danhMuc.listICD10);
	};

	return (
		<div className="spaces pt-8">
			<div className="d-flex flex-wrap align-items-start">
				<label className="text-lable-input spaces mr-8 pt-10">
					<i className="bi bi-dot text-dark fs-2"></i>
					Bệnh chính:
				</label>
				<Row className="flex-1 position-relative max-w-100">
					<ProvisonalDiagnosis
						encounterDiagnosisValues={values}
						encounterDiagnosisErrors={errors}
						encounterDiagnosisTouched={touched}
						listComorbidity={listComorbidity}
						setListComorbidity={setListComorbidity}
						onChange={(data: any) =>
							setValues({
								...values,
								...data,
							})
						}
						handleChangeEncounterDiagnosis={setFieldValue}
					/>
				</Row>
			</div>

			<div className="spaces pt-15">
				<span className="d-flex align-items-baseline spaces pb-4">
					<i className="bi bi-dot text-dark fs-2"></i>
					<Button
						className="link-info bg-white text-decoration-underline spaces p-0"
						onClick={() => {
							setOpenSelectICD10Dialog(true);
						}}
					>
						Bệnh kèm theo (nếu có):
					</Button>
				</span>
				<TextField name="comorbidity" as="textarea" />
			</div>

			{showPhanBiet && (
				<div className="d-flex align-items-baseline">
					<i className="bi bi-dot text-dark fs-2"></i>
					<TextField name="differentialDiagnosis" label="Phân biệt:" className="flex-1" />
				</div>
			)}

			<ICD10
				shouldOpenModalICD10={openICD10Dialog}
				setShouldOpenModalICD10={setOpenICD10Dialog}
				shouldOpenModalSelectICD10={openSelectICD10Dialog}
				setShouldOpenModalSelectICD10={setOpenSelectICD10Dialog}
				listICD10={listICD10}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10="radio"
				data={values}
				onChange={value => {
					setValues({
						...values,
						...value,
					});
				}}
			/>
		</div>
	);
};

export default ThongTinBenh;
